import Model from './Model'
import { newDate } from 'utils'

export default class TimezonedModel extends Model {

	/** @type string */ timezone_id

	constructor({ timezone_id, ...attrs }) {
		super()
		if (!timezone_id) {
			console.error('Tried creating a TimezonedModel without a timezone 🤡', { timezone_id, ...attrs })
		}
		this.timezone_id = timezone_id
		Object.assign(this, attrs) //repeats what's in Model but ensures timezone is always the first field to be set
	}

	newDate(date = null) {
		return newDate(this.timezone_id, date)
	}

}
